var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44156 1.71429C6.44156 1.16952 6.8838 0.727273 7.42857 0.727273H8.57143C9.1162 0.727273 9.55844 1.16952 9.55844 1.71429V14.2857C9.55844 14.8305 9.1162 15.2727 8.57143 15.2727H7.42857C6.8838 15.2727 6.44156 14.8305 6.44156 14.2857V1.71429ZM0.727273 8.57143C0.727273 8.02666 1.16952 7.58442 1.71429 7.58442H2.85714C3.40191 7.58442 3.84416 8.02666 3.84416 8.57143V14.2857C3.84416 14.8305 3.40191 15.2727 2.85714 15.2727H1.71429C1.16952 15.2727 0.727273 14.8305 0.727273 14.2857V8.57143ZM13.1429 3.01299H14.2857C14.8305 3.01299 15.2727 3.45523 15.2727 4V14.2857C15.2727 14.8305 14.8305 15.2727 14.2857 15.2727H13.1429C12.5981 15.2727 12.1558 14.8305 12.1558 14.2857V4C12.1558 3.45523 12.5981 3.01299 13.1429 3.01299Z",
    stroke: "#898E99",
    strokeWidth: 1.45455
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.0e6d63722b60afa90978535e270ab4ab.svg";
export { ForwardRef as ReactComponent };